export class NumberFormatter {
  private readonly formatter: Intl.NumberFormat;

  constructor(locale: string, options?: Intl.NumberFormatOptions) {
    this.formatter = new Intl.NumberFormat(locale, options);
  }

  format(value: number): string {
    return this.formatter.format(value);
  }
}
